import { DefaultSeo } from 'next-seo';

import { CREHANA_BASE_URL_SEO_PRD } from '@crehana/constants';
import { useTranslation } from '@crehana/i18n';
import { nextSeoDefaultProps } from '@crehana/next';

import localeEs from './i18n/localeEs';

const B2BLandingDefaultSeo = () => {
  const { t } = useTranslation();

  return (
    <DefaultSeo
      {...nextSeoDefaultProps}
      titleTemplate={`%s | ${t('CREHANA_FOR_BUSINESS', {
        defaultValue: localeEs.es.CREHANA_FOR_BUSINESS,
      })}`}
      description={t('SEO_DESCRIPTION', {
        defaultValue: localeEs.es.SEO_DESCRIPTION,
      })}
      canonical={`${CREHANA_BASE_URL_SEO_PRD}/business/`}
      openGraph={{
        type: 'website',
        site_name: CREHANA_BASE_URL_SEO_PRD,
        images: [
          {
            url: 'https://crehana-vercel-images-prd.imgix.net/public/33afa9e0-467c-476f-814a-6c63bec837bb-imagen_seo2.png?auto=format&fit=clip',
            alt: t('CREHANA_FOR_BUSINESS', {
              defaultValue: localeEs.es.CREHANA_FOR_BUSINESS,
            }),
          },
        ],
      }}
      languageAlternates={[
        {
          href: `${CREHANA_BASE_URL_SEO_PRD}/business/`,
          hrefLang: 'es',
        },
      ]}
    />
  );
};

export default B2BLandingDefaultSeo;
